import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '../../config/constants';

export const getWorkspacePermissionApi = ({ spaceId, folderId }) => {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/view/space/${spaceId}/folder/${folderId}/field-permission`,
        method: 'GET',
        transformCode: true,
        uuid: `field-permission-${spaceId}-${folderId}`,
        cache: true,
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getWorkspaceFieldValueApi = ({ patent_id, folder_id, view_type, space_type }) => {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/view/folder/${folder_id}/patent/${patent_id}/field-values`,
        method: 'GET',
        params: {
            view_type,
            /** 传入 'all' 会获取所有有权限的字段 */
            space_type,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const getWorkspaceInfoApi = ({ folder_id }) => {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/view/folder/${folder_id}/workspace-info`,
        method: 'GET',
        transformCode: true,
        uuid: `workspace-info-${folder_id}`,
        cache: true,
    }).then(({ data }) => {
        return data.data || {};
    });
};

export const savePatentsToWorkspaceApi = ({
    space_id,
    folder_id,
    auto,
    source_type,
    type = 'PATENT',
    patent_count,
    patent_ids,
}) => {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/space/${space_id}/folder/${folder_id}/patents/v2`,
        method: 'PUT',
        data: {
            space_id,
            folder_id,
            auto,
            source_type,
            type,
            patent_count,
            patent_ids,
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
};
